module.exports = __webpack_public_path__ + "static/media/science-background.66aac186.png";